/**
 * Sticky Buy Bar
 *
 * Toggles a class on the original product buy buttons to make them
 * position: fixed at the bottom of the viewport when scrolled out of view.
 *
 * Fixes the CSS containing-block issue caused by `transform` on ancestor
 * .scroll-trigger.animate--slide-in elements by nullifying the transform
 * after the entrance animation completes.
 */
(function () {
  'use strict';

  function initStickyBuyBar() {
    var sentinels = document.querySelectorAll('.product-form__buttons-wrapper');
    if (!sentinels.length) return;

    sentinels.forEach(function (sentinel) {
      if (sentinel.dataset.stickyObserverAttached) return;
      sentinel.dataset.stickyObserverAttached = 'true';

      var buttonsEl = sentinel.querySelector('[data-sticky-buy-bar]');
      if (!buttonsEl) return;

      // Fix: Remove the CSS transform on the nearest scroll-trigger ancestor
      // so that position: fixed on the buttons works relative to the viewport.
      fixAncestorTransform(sentinel);

      var isSticky = false;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              activate(buttonsEl, sentinel);
              isSticky = true;
            } else if (isSticky) {
              deactivate(buttonsEl, sentinel);
              isSticky = false;
            }
          });
        },
        { threshold: 0 }
      );

      observer.observe(sentinel);
    });
  }

  /**
   * The .product__info-wrapper has .scroll-trigger.animate--slide-in which
   * sets transform: translateY(2rem) as a base style and animates to
   * translateY(0). Both values create a CSS containing block that breaks
   * position: fixed on descendants. After the animation finishes, we
   * clear the transform so fixed positioning works against the viewport.
   */
  function fixAncestorTransform(el) {
    var ancestor = el.closest('.scroll-trigger.animate--slide-in');
    if (!ancestor) return;

    function clearTransform() {
      ancestor.style.animation = 'none';
      ancestor.style.transform = 'none';
      ancestor.style.opacity = '1';
    }

    // If the animation already completed (element is visible / not offscreen)
    if (!ancestor.classList.contains('scroll-trigger--offscreen')) {
      clearTransform();
    }

    // Also listen for animation end in case it hasn't fired yet
    ancestor.addEventListener('animationend', clearTransform, { once: true });
  }

  function activate(buttonsEl, sentinel) {
    var submitBtn = buttonsEl.querySelector('.product-form__submit');
    if (submitBtn && submitBtn.disabled) return;

    sentinel.style.minHeight = buttonsEl.offsetHeight + 'px';
    buttonsEl.classList.remove('sticky-buy-bar--hiding');
    buttonsEl.classList.add('sticky-buy-bar--active');
  }

  function deactivate(buttonsEl, sentinel) {
    buttonsEl.classList.add('sticky-buy-bar--hiding');

    buttonsEl.addEventListener(
      'animationend',
      function () {
        buttonsEl.classList.remove('sticky-buy-bar--active', 'sticky-buy-bar--hiding');
        sentinel.style.minHeight = '';
      },
      { once: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBuyBar);
  } else {
    initStickyBuyBar();
  }

  document.addEventListener('shopify:section:load', initStickyBuyBar);
})();
